import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TableViewer from './TableViewer';
import AddData from './AddData';
import ExcelJS from 'exceljs';
import axios from 'axios';

import { ReactComponent as ExportIcon } from '../icons/home/export.svg';
import { ReactComponent as SaveIcon } from '../icons/home/save.svg';
import { ReactComponent as TrashIcon } from '../icons/home/trash.svg';
import { ReactComponent as CopyIcon } from '../icons/home/copy.svg';

import { API_BASE_URL, ItemList, renderModal, closeModal, renderConfirmationModal, handleDelete, handleDuplicate, fetchData, LoadingOverlay, evaluateData, Breadcrumbs, IconButton } from './Common';


function Project() {
  const { projectId } = useParams();
  const [tables, setTables] = useState([]);
  const [tableColumnData, setTableColumnData] = useState([]);
  const [isTableColumnDataLoaded, setIsTableColumnDataLoaded] = useState(false);
  const [isTablesLoaded, setIsTablesLoaded] = useState(false);

  //const [isDuplicating, setIsDuplicating] = useState(false);
  const [exportModalVisible, setExportModalVisible] = useState(false);
   const [exportModalVisibleAll, setExportModalVisibleAll] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState('JSON');
  const [selectedTableId, setSelectedTableId] = useState(null);

  const [spinnerMessage, setSpinnerMessage] = useState(null);

  const [addData, setAddData] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [tableToDelete, setTableToDelete] = useState(null);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const [isDuplicating, setIsDuplicating] = useState(false);

  const [modalIconId, setModalIconId] = useState(0);

  const [currentPage, setCurrentPage] = useState(1); // Track current page number
  const itemsPerPage = 10; // Maximum items per page

  const [projectName, setProjectName] = useState('');
  const [isProjectNameLoaded, setIsProjectNameLoaded] = useState(false);
  const [columnToDelete, setColumnToDelete] = useState(null);
  const [rowToDelete, setRowToDelete] = useState(null);

  const handleDeleteRowClick = (rowId, rowIndex, removeRowFn) => {
  setRowToDelete({ rowId, rowIndex, removeRowFn });
  setIsConfirmationModalOpen(true);
};

  const handleDeleteColumnClick = (columnId) => {
  setColumnToDelete(columnId);
  setIsConfirmationModalOpen(true);
};

  const handleDataCreated = () => {
  setAddData(false);

  setModalMessage("Projeto atualizado!");
  setModalMessageColor('#41BBC9');
  setModalIconId(1);
  setIsModalOpen(true);
};

  useEffect(() => {

    fetchData(`${API_BASE_URL}/project/${projectId}`, setProjectName, setIsProjectNameLoaded, 'name');

    fetchData(`${API_BASE_URL}/tables/${projectId}`, setTables, setIsTablesLoaded, 'tables');

    fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');

  }, [projectId]); // Include projectId in the dependency array to refetch tables when projectId changes


  const handleSaveTable = async (tableId) => {

    setModalMessage("Dados guardados!");
    setModalMessageColor('#43BBC9');
    setModalIconId(3);
    setIsModalOpen(true);


  };

  const handleExportTable = async (tableId) => {
    setSelectedTableId(tableId);
    setExportModalVisible(true);
  };

  const handleExportAll = async (tableId) => {
    setExportModalVisibleAll(true);
  };

const handleDownload = async (tableId = null) => {
  // Determine if we export all or one table
  const fileData = tableId === null ? tables : { [tableId]: tables[tableId] };
  const fileName = tableId === null
    ? `tabelas.${selectedFormat.toLowerCase()}`
    : `${tables[tableId].table_name}.${selectedFormat.toLowerCase()}`;

  let blob;

  if (selectedFormat === 'CSV') {
    // For CSV, we can only export one table at a time
    const exportTables = tableId === null ? Object.values(tables) : [tables[tableId]];

    // We'll concatenate multiple tables with headers
    let formattedData = '';

    exportTables.forEach((table, index) => {
      const { columnNames, transposedData } = processTableData(table, tableColumnData);

      // Optional: add table name as header if exporting multiple tables
      if (tableId === null && exportTables.length > 1) {
        formattedData += `Tabela: ${table.table_name}\n`;
      }

      formattedData += columnNames.join(';') + '\n';
      transposedData.forEach(row => {
        formattedData += row.join(';') + '\n';
      });

      if (tableId === null && index < exportTables.length - 1) {
        formattedData += '\n'; // Add empty line between tables
      }
    });

    blob = new Blob([formattedData], { type: 'text/plain' });

  } else if (selectedFormat === 'JSON') {
    const data = {};

    await Promise.all(
      Object.entries(fileData).map(([id, table]) => {
        const { columnNames, transposedData } = processTableData(table, tableColumnData);
        data[table.table_name] = { columnNames, transposedData };
      })
    );

    blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });

  } else if (selectedFormat === 'XLSX') {
    const data = {};

    await Promise.all(
      Object.entries(fileData).map(([id, table]) => {
        const { columnNames, transposedData } = processTableData(table, tableColumnData);
        data[table.table_name] = { columnNames, transposedData };
      })
    );

    const workbook = new ExcelJS.Workbook();

    Object.entries(data).forEach(([tableName, { columnNames, transposedData }]) => {
      const worksheetName = sanitizeName(tableName);
      const worksheet = workbook.addWorksheet(worksheetName);

      worksheet.addRow(columnNames);
      worksheet.addRows(transposedData);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

  // Trigger download
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = sanitizeFileName(fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Close modals and show success
  setExportModalVisible(false);
  setExportModalVisibleAll(false);
  setModalMessage('Dados Exportados!');
  setModalMessageColor('#233A80');
  setModalIconId(0);
  setIsModalOpen(true);
};


const sanitizeName = (name) => {
  // Replace any characters not allowed in worksheet names
  return name.replace(/[\\/*?:]/g, '_').substring(0, 31); // Limit to 31 characters
};

const sanitizeFileName = (name) => {
  return name.replace(/[\\/*?:"]/g, '_');
};

function processTableData(selectedTable, tableColumnData) {
    selectedTable.columns.forEach(column => {
        const { column_id } = column;

        if (tableColumnData[column_id]) {
            column.data = tableColumnData[column_id].data;
        }
    });

    const tableData = selectedTable.columns.map(column => column.data);
    const columnNames = selectedTable.columns.map(column => column.column_name);
    const transposedData = tableData[0].map((_, colIndex) => tableData.map(row => row[colIndex]));

    return { columnNames, transposedData };
}

function ExportModal(visible, handleDownloadFunc, setModalVisibleFunc, showCSVOption) {

  const handleCheckboxChange = (format) => {
    if (selectedFormat !== format) {
      setSelectedFormat(format);
    }
  };

  return (
    visible && (
      <div className="export-modal">
      <ExportIcon/>
      <span className="close" onClick={() => setModalVisibleFunc(false)}>&times;</span>
      <p className="modal-title">Exportar dados</p>
      <p className="modal-intro">Selecionar formato</p>
      <div>
        {showCSVOption && (
          <label>
            <input
              type="checkbox"
              value="CSV"
              checked={selectedFormat === 'CSV'}
              onChange={() => handleCheckboxChange('CSV')}
            />
            <span>CSV</span>
          </label>
        )}
        <label>
          <input
            type="checkbox"
            value="XLSX"
            checked={selectedFormat === 'XLSX'}
            onChange={() => handleCheckboxChange('XLSX')}
          />
          <span>XLSX</span>
        </label>
        <label>
          <input
            type="checkbox"
            value="JSON"
            checked={selectedFormat === 'JSON'}
            onChange={() => handleCheckboxChange('JSON')}
          />
          <span>JSON</span>
        </label>
      </div>
      <button onClick={() => handleDownloadFunc(selectedFormat)}>
      <span>Download</span>
      </button>
    </div>
    )
  );
}

const confirmDelete = async () => {

  setModalIconId(0);
  const token = localStorage.getItem('token');

  if (columnToDelete) {

    await axios.post(`${API_BASE_URL}/remove-column`, {
      columnId: columnToDelete
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });

    fetchData(`${API_BASE_URL}/tables/${projectId}`, setTables, setIsTablesLoaded, 'tables');
    fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');

    setColumnToDelete(null);

  } else if (rowToDelete) {

    rowToDelete.removeRowFn(rowToDelete.rowId, rowToDelete.rowIndex);

    setRowToDelete(null);

  }
  else if (tableToDelete) {

    setSelectedTableId(null);
    await handleDelete(
      'tables',
      projectId,
      tableToDelete,
      token,
      setTables,
      tables,
      setModalMessage,
      setModalMessageColor,
      setIsModalOpen,
      currentPage,
      setCurrentPage,
      itemsPerPage
    );
  }

  setIsConfirmationModalOpen(false);
};

const handleDeleteClick = (tableId) => {
        setTableToDelete(tableId);
        setIsConfirmationModalOpen(true);
    };

const handleDuplicateTable = async (tableId) => {
  try {
    // Call handleDuplicate and wait for it to finish
    await handleDuplicate(
      'table',
      tableId,
      setTables,
      tables,
      'Tabela Duplicada!',
      setIsDuplicating,
      setModalMessage,
      setModalMessageColor,
      setIsModalOpen
    );

    // Fetch data only after duplication is complete
    fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');
  } catch (error) {
    console.error('Error during duplication or data fetching:', error);
  }
};

const hasReadOnlyPermission = Object.values(tables).some(table => table.permission === 'read-only');
//console.log("tableColumnData: " + JSON.stringify(tableColumnData));
//console.log(JSON.stringify(tables, null, 2));
  return (
    <>

<div className="home-container">

    <Breadcrumbs
  items={
    selectedTableId
      ? [
          { label: "Projetos", path: "/home" },
          { label: projectName, onClick: () => setSelectedTableId(null) },
          { label: tables[selectedTableId]?.table_name || "Tabela" },
        ]
      : addData
      ? [
          { label: "Projetos", path: "/home" },
          { label: projectName, onClick: () => setAddData(false) },
          { label: "Upload de dados" },
        ]
      : [
          { label: "Projetos", path: "/home" },
          { label: projectName },
        ]
  }
/>

    {addData && (
      <AddData
        setTableColumnData={setTableColumnData}
        setTables={setTables}
        projectId={projectId}
        onDataCreated={handleDataCreated}
      />
    )}

  {!addData && (<>

    <p className="text0">Gerir dados</p>
    <p>Pré-visualizar tabelas</p>
    <p className="text1">{projectName}</p>

{/************************************************* Tabela com dados*/}
{selectedTableId && (
  <div style=
  {{
    //height: 'calc(100% - 98px)',
    width: '100%',
  }}>
      <TableViewer
        tableColumnData={evaluateData(tableColumnData)}
        setTableColumnData={setTableColumnData}
        isTablesLoaded={isTablesLoaded}
        setIsTableColumnDataLoaded={setIsTableColumnDataLoaded}
        table={tables[selectedTableId]}
        setIsDuplicating={setIsDuplicating}
        setSpinnerMessage={setSpinnerMessage}

        selectedTableId={selectedTableId}
        tables={tables}
        setTables={setTables}
        projectId={projectId}

        onSave={handleSaveTable}
        onExport={handleExportTable}
        onDelete={handleDeleteClick}
        onDuplicate={handleDuplicateTable}
        onDeleteColumn={handleDeleteColumnClick}
        onDeleteRow={handleDeleteRowClick}
      />
      </div>
)}

{/************************************************* Lista de tabelas*/}
{!selectedTableId && (
<ItemList
      tipo="table"
      isLoaded={isTablesLoaded}
      onEdit={setSelectedTableId}
      onDelete={handleDeleteClick}
      onDuplicate={handleDuplicateTable}
      onExport={handleExportTable}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        DataArray={tables}
        itemsPerPage={itemsPerPage}
      />
)}
{/*************************************************/}
</>)}

{/*Confirm delete*/}
{renderConfirmationModal(
  isConfirmationModalOpen,
  columnToDelete
    ? "Tem a certeza que pretende eliminar esta coluna?"
    : rowToDelete
    ? "Tem a certeza que pretende eliminar esta linha?"
    : "Tem a certeza que pretende eliminar esta tabela?",
  confirmDelete,
  () => {
    setIsConfirmationModalOpen(false);
    setColumnToDelete(null);
    setRowToDelete(null);
    setTableToDelete(null);
  }
)}

{/*Delete ou Export sucess*/}
{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}

{ExportModal(exportModalVisible, () => handleDownload(selectedTableId), setExportModalVisible, true)}

{ExportModal(exportModalVisibleAll, () => handleDownload(), setExportModalVisibleAll, false)}


<div className="button-container">

{!(addData || selectedTableId) && (
<button
  className="button"
  onClick={() => {
    if (!isTablesLoaded || (hasReadOnlyPermission && !addData && !selectedTableId)) {
      return; // Prevent any action if tables are not loaded or if in read-only mode
    }
    if (selectedTableId) {
      setSelectedTableId(null);
    } else {
      setAddData((prevState) => !prevState); // Toggle state to show/hide ChartWidgetCreator
    }
  }}
  style={{
    cursor: !isTablesLoaded || (hasReadOnlyPermission && !addData && !selectedTableId) ? 'not-allowed' : 'pointer',
    opacity: !isTablesLoaded || (hasReadOnlyPermission && !addData && !selectedTableId) ? 0.5 : 1,
  }}
  disabled={!isTablesLoaded || (hasReadOnlyPermission && !addData && !selectedTableId)} // Disable button if tables are not loaded or in read-only mode
>
  <span>
    {(addData || selectedTableId) ? 'Voltar a tabelas' : 'Upload de dados'}
  </span>
</button>
)}

{selectedTableId && (
    <div className="icons-container" style={{ display: 'flex', gap: '35px' }}>
      <IconButton
        Icon={SaveIcon}
        action={handleSaveTable}
        tableId={tables[selectedTableId].table_id}
        permission={tables[selectedTableId].permission}
        tooltip="Guardar"
      />

      <IconButton
        Icon={CopyIcon}
        action={handleDuplicateTable}
        tableId={tables[selectedTableId].table_id}
        permission={tables[selectedTableId].permission}
        tooltip="Duplicar"
      />

      <IconButton
        Icon={TrashIcon}
        action={handleDeleteClick}
        tableId={tables[selectedTableId].table_id}
        permission={tables[selectedTableId].permission}
        tooltip="Eliminar"
      />

      <IconButton
        Icon={ExportIcon}
        action={handleExportTable}
        tableId={tables[selectedTableId].table_id}
        permission={tables[selectedTableId].permission}
        tooltip="Exportar"
      />
    </div>
  )}



{(!addData && !selectedTableId) && (
<>
<button className="button" onClick={() => handleExportAll()}>
Exportar tudo
</button>
{/*
<button className="button">
  DER
</button>
*/}
</>
)}
</div>

<LoadingOverlay isDuplicating={isDuplicating} spinnerMessage={spinnerMessage}/>

</div>
</>
);

}

export default Project;
